import React, { useEffect } from "react";
import { Dialog, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./Splash.css";

const Splash = ({ open }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                navigate("/login");
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [open, navigate]);

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            disableEscapeKeyDown
            onClose={() => { }}
            BackdropProps={{
                sx: {
                    backdropFilter: "blur(8px)",
                    backgroundColor: "rgba(0,0,0,0.55)",
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: "18px",
                    padding: "36px 30px",
                    textAlign: "center",
                    background: "linear-gradient(145deg,#0E1116 0%,#121720 55%,#0E1116 100%)",
                    color: "#fff",
                    border: "1px solid rgba(255,255,255,0.05)",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
                },
            }}
        >
            <Box className="signup-popup-container">

                <div className="lottie-wrapper">
                    <CheckCircleIcon className="success-tick" />
                    <iframe
                        title="signup-success"
                        src="https://lottie.host/embed/ac37332d-55fd-4da7-8d50-1214c043c268/2Ql6PhchZY.lottie"
                        className="lottie-frame"
                    />
                </div>

                <Typography className="signup-title">
                    Signup Successful
                </Typography>

                <Typography className="signup-subtitle">
                    Welcome to <span className="brand">Unitic Exchange</span>
                </Typography>

                <div className="loader-wrapper">
                    <div className="progress-bar"></div>
                </div>

            </Box>
        </Dialog>
    );
};

export default Splash;